import React from 'react';
import dhalaan from '../../assets/images/team-members/dhalaan@2x.png';
import haidry from '../../assets/images/team-members/haidry@2x.png';
import khalid from '../../assets/images/team-members/khalid@2x.png';
import majid from '../../assets/images/team-members/majid@2x.png';
import qahtani from '../../assets/images/team-members/qahtani@2x.png';
import tariq from '../../assets/images/team-members/tariq@3x.png';
import womenProfile from '../../assets/images/team-members/women-profile@2x.png';
import wuhiabi from '../../assets/images/team-members/wuhaibi@2x.png';
import { useTranslation } from 'react-i18next';

function Team() {
    const { t, i18n } = useTranslation();
    return (
        <div className='center-team mx-auto col'>
            <div className='team-word row'>
                <h1>{t('who.board')}</h1>
            </div>
            <div className='row'>
                <div className='d-flex justify-content-around flex-wrap'>
                    <div>
                        <img src={majid} className='team-img' />
                        <div className='team-member'>
                            <h4>{t('who.boardMembers.majed.name')}</h4>
                            <h6>{t('who.boardMembers.majed.position')}</h6>
                            <h6>{t('who.boardMembers.majed.member')}</h6>
                        </div>
                    </div>
                    <div>
                        <img src={khalid} className='team-img' />
                        <div className='team-member'>
                            <h4>{t('who.boardMembers.khaled.name')}</h4>
                            <h6>{t('who.boardMembers.khaled.position')}</h6>
                            <h6>{t('who.boardMembers.khaled.member')}</h6>
                        </div>
                    </div>
                    <div>
                        <img src={tariq} className='team-img' />
                        <div className='team-member'>
                            <h4>{t('who.boardMembers.tarek.name')}</h4>
                            <h6>{t('who.boardMembers.tarek.position')}</h6>
                            <h6>{t('who.boardMembers.tarek.member')}</h6>
                        </div>
                    </div>
                    <div>
                        <img src={wuhiabi} className='team-img' />
                        <div className='team-member'>
                            <h4>{t('who.boardMembers.abdullahW.name')}</h4>
                            <h6>{t('who.boardMembers.abdullahW.position')}</h6>
                            <h6>{t('who.boardMembers.abdullahW.member')}</h6>
                        </div>
                    </div>
                    <div>
                        <img src={womenProfile} className='team-img' />
                        <div className='team-member'>
                            <h4>{t('who.boardMembers.basma.name')}</h4>
                            <h6>{t('who.boardMembers.basma.position')}</h6>
                            <h6>{t('who.boardMembers.basma.member')}</h6>
                        </div>
                    </div>
                    <div>
                        <img src={womenProfile} className='team-img' />
                        <div className='team-member'>
                            <h4>{t('who.boardMembers.maha.name')}</h4>
                            <h6>{t('who.boardMembers.maha.position')}</h6>
                            <h6>{t('who.boardMembers.maha.member')}</h6>
                        </div>
                    </div>
                    <div>
                        <img src={qahtani} className='team-img' />
                        <div className='team-member'>
                            <h4>{t('who.boardMembers.abdullahK.name')}</h4>
                            <h6>{t('who.boardMembers.abdullahK.position')}</h6>
                            <h6>{t('who.boardMembers.abdullahK.member')}</h6>
                        </div>
                    </div>
                    <div>
                        <img src={dhalaan} className='team-img' />
                        <div className='team-member'>
                            <h4>{t('who.boardMembers.heshamD.name')}</h4>
                            <h6>{t('who.boardMembers.heshamD.position')}</h6>
                            <h6>{t('who.boardMembers.heshamD.member')}</h6>
                        </div>
                    </div>
                    <div>
                        <img src={haidry} className='team-img' />
                        <div className='team-member'>
                            <h4>{t('who.boardMembers.hishamH.name')}</h4>
                            <h6>{t('who.boardMembers.hishamH.position')}</h6>
                            <h6>{t('who.boardMembers.hishamH.member')}</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Team;
